<template>
  <span class="echarts-pagoda">
    <div id="mainPagoda"></div>
  </span>
</template>

<script>
  import * as echarts from 'echarts';
  import GetFormatTime from '@/utils/time-format.js';
  export default {
    props: {
      data: {
        type: [Object, Array],
        default () {
          return {
            xAxis: [0, 0, 0, 0, 0, 0, 0],
            series: [0, 0, 0, 0, 0, 0, 0]
          };
        }
      }
    },
    data() {
      return {};
    },
    methods: {
      init() {
        if (this.data.xAxis.length == 0) {
          let xAxis = [];
          let series = [];
          let timeList = [];
          let time = new Date().getTime();
          for (let i = 1; i < 8; i++) {
            timeList.push(time - i * 24 * 3600 * 1000);
          }
          timeList.sort(function(a, b) {
            return a - b;
          });
          for (let j = 0; j < timeList.length; j++) {
            xAxis.push(GetFormatTime({
              time: timeList[j],
              format: "yyyy-MM-dd"
            }))
            series.push(0);
          }
          this.data.xAxis = xAxis;
          this.data.series = series;
        }
        let op = {
          grid: {
            left: '12%',
            top: '25%',
            bottom: '25%',
            right: '4%'
          },
          xAxis: {
            data: this.data.xAxis,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 129, 109,.1)',
                width: 1 //这里是为了突出显示加上的
              }
            },
            axisLabel: {
                color: '#08265F',
                fontSize: 10,
              formatter: function(params) {
                let res = '';
                let strs = [];
                let y = '',
                  m = '',
                  d = '';
                strs = params.split('-');
                y = strs[0];
                m = strs[1];
                d = strs[2];
                return m + '-' + d + "\n" + y
              }
            }
          },
          yAxis: [{
            name: '收益(元)',
            nameTextStyle: {
              color: '#08265F',
              fontSize: 12,
              padding: [10, 0, 0, -20]
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 1 //这里是为了突出显示加上的
              }
            },
            axisLabel: {
                fontSize: 10,
                color: '#08265F'
            },
            splitArea: {
              areaStyle: {
                color: 'rgba(255,255,255,.5)'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 0.5,
                type: 'dashed'
              }
            }
          }],
          series: [{
            type: 'pictorialBar',
            barCategoryGap: '0%',
            symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
            label: {
              show: true,
              position: 'top',
              distance: 0,
              color: '#08265F',
              fontWeight: 'bolder',
              fontSize: 10,
              rotate: 45,
            },
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0,
                    color: '#9A11FF'
                  },
                  {
                    offset: 1,
                    color: '#08DFFE'
                  }
                ],
                global: false //  缺省为  false
              }
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
              }
            },
            data: this.data.series
          }]
        };
        return op;
      },
      load() {
        this.$nextTick(function() {
          let ct = echarts.getInstanceByDom(document.getElementById('mainPagoda'));
          if (ct == undefined) {
            ct = echarts.init(document.getElementById('mainPagoda'));
          }
          let tmp = this.init();
          if (tmp) {
            ct.setOption(tmp);
          } else {
            console.log('数据问题pagoda');
          }
        });
      }
    },
    mounted() {
      this.load();
    }
  };
</script>

<style lang="scss">
  .echarts-pagoda {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: inline-block;

    #mainPagoda {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/echarts-pagoda.vue